<script>
    import PageFooter from "./components/PageFooter.svelte";
    import PageHeader from "./components/PageHeader.svelte";
    import Modal from "./components/Modal.svelte";
    import ErrorModal from "./components/ErrorHandling/ErrorModal.svelte";
    import Router from "./routes/Router.svelte";

    export let url = "";
    
    const basepath = window.basePath || '/';

    const disableSubmitOnEnter = (e) => {
        if (e.which != '13') return;

        if (e.target && e.target.type && e.target.type != "textarea") {
            e.preventDefault();
        }
    }

</script>

<svelte:head>
    <!-- Google Tag Manager -->
    <script>
        (function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
            var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s),
                dl = l != "dataLayer" ? "&l=" + l : "";
            j.async = true;
            j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, "script", "dataLayer", "GTM-TW92CF2W");
    </script>
    <!-- End Google Tag Manager -->
</svelte:head>

<main>

    <div class="page-container"
         on:keypress={(e) => disableSubmitOnEnter(e)}
         style="--highlight-color: #e46937; --error-color: #D83737;">
        <PageHeader></PageHeader>

        <Modal>
            <ErrorModal>
                <Router {url} {basepath}></Router>
            </ErrorModal>
        </Modal>
    </div>

    <PageFooter></PageFooter>

</main>

<style>
    .page-container {
        min-height: calc(100vh - 155px);
    }

    /*  GLOBAL STYLES  */

    :global(.char-tracker) {
		position: relative;
	}

    :global(.char-tracker span) {
		display: none;
	}
	
	:global(.char-tracker span) {
		position: absolute;
		right: 2px;
		font-size: 10px;
		opacity: .75;
		bottom: 0;
	}

	:global(.char-tracker span.limited) {
		color: var(--error-color);
	}

    :global(.char-tracker-wrap:has(input:focus) .char-tracker span, .char-tracker-wrap:has(textarea:focus) .char-tracker span) {
	    display: inline-block;
    }

</style>